
export const REQUEST_PROGRAM = 'program/REQUEST_PROGRAM';
export const REQUEST_PROGRAM_WEEKS = 'program/REQUEST_PROGRAM_WEEKS';
export const REQUEST_PROGRAM_WORKOUTS = 'program/REQUEST_PROGRAM_WORKOUTS';
export const REQUEST_PROGRAM_ASSIGNMENTS = 'program/REQUEST_PROGRAM_ASSIGNMENTS';
export const REQUEST_ADD_PROGRAM_WORKOUT = 'program/REQUEST_ADD_PROGRAM_WORKOUT';
export const REQUEST_ADD_PROGRAM_WEEK = 'program/REQUEST_ADD_PROGRAM_WEEK';
export const REQUEST_COPY_PROGRAM_WEEK = 'program/REQUEST_COPY_PROGRAM_WEEK';
export const REQUEST_DUPLICATE_PERSONAL_PROGRAM_WORKOUT = 'program/REQUEST_DUPLICATE_PERSONAL_PROGRAM_WORKOUT';
